module.exports = __webpack_public_path__ + "static/media/youtube_round.505b8082.svg";